import AjaxClass from './Validation/ajaxClass';

export default function bootstrapForms() {
    document.querySelectorAll('form.needs-validation').forEach(formElement => {
        if (formElement.classList.contains('custom')) {
            return false;
        }
        formElement.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
    
            let form = this;
            let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));
            let images = form.querySelectorAll('input[type=file]');
            if (images.length > 0) {
                images.forEach(e => {
                    let image = { name: e.name, value: e.files[0] };
                    fields.push(image);
                });
            }
    
            if (!form.checkValidity()) {
                form.classList.add('was-validated')
                return false
            }
    
            if (form.checkValidity()) {
                let formData = new FormData(form);
                if (images.length > 0) {
                    fields.forEach(obj => {
                        if (!obj.value) obj.value = '';
                        formData.append(obj.name, obj.value);
                    });
                }
    
                form.disabled = true;
                let type = 'POST';
                let url = form.action;
                let dataType = 'json';
    
                const modalSuccess = document.getElementById('success-message-forms');
                const modalSuccessDescription = document.querySelector('#success-message-forms .description');
                const modalError = document.getElementById('error-message-forms');
                const modalDescription = document.querySelector('#error-message-forms .description');
                const Loader = document.getElementById("loading-forms");
                Loader.classList.add("open-modal");
                class Form extends AjaxClass {
                    successFunction(data, form) {
                        Loader.classList.remove("open-modal");
                        if (data.status === true) {
                            form.reset();
                            form.disabled = false;
                            if (data.redirect) {
                                window.location = data.redirect;
                            } else {
                                modalSuccess.classList.add("open-modal");
                                modalSuccessDescription.innerHTML = data.txt;
                            }
                        } else {
                            modalDescription.innerHTML = data.txt;
                            modalError.classList.add("open-modal");
                            form.disabled = false;
                        }
                    }
    
                    errorFunction(xhr, textStatus, errorThrown) {
                        Loader.classList.remove("open-modal");
                        modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
    
                        if (errorThrown === 'Too Many Requests' || xhr.responseText === 'Too Many Requests') {
                            modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                        }

                        if (xhr.status === 419) {
                            // CSRF expirado
                            modalDescription.innerHTML = "Sessão expirada. Recarregando...";
                            setTimeout(() => location.reload(), 2000);
                        }
    
                        modalError.classList.add("open-modal");
                        form.disabled = false;
                    }
                }
    
                let ajax = new Form(form, type, url, dataType, formData);
                ajax.send();
            }
    
            return false;
        });
    });
    
    document.querySelectorAll('[phone]').forEach(phoneElement => {
        phoneElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
    
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode) || (charCode === 190 && !this.value.includes('.'))) {
                return;
            }
    
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        phoneElement.addEventListener('blur', function () {
            mascaraDeTelefone(this);
        });
    
        phoneElement.addEventListener('focus', function () {
            tiraHifen(this);
        });
    });
    
    function mascaraDeTelefone(telefone) {
        const textoAtual = telefone.value.replace(/[^0-9]/g, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
    
        if (isCelular) {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 7);
            const parte3 = textoAtual.slice(7, 11);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        } else {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 6);
            const parte3 = textoAtual.slice(6, 10);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        }
    
        telefone.value = textoAjustado || null;
    }
    
    function tiraHifen(telefone) {
        telefone.value = telefone.value.replace(/\./g, '');
    }
    
    document.querySelectorAll('[cnpj]').forEach(cnpjElement => {
        cnpjElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cnpjElement.addEventListener('blur', function () {
            aplicarMascaraCNPJ(this);
        });
    
        cnpjElement.addEventListener('focus', function () {
            removerMascaraCNPJ(this);
        });
    });
    
    function aplicarMascaraCNPJ(cnpj) {
        const textoAtual = cnpj.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 2);
        const parte2 = textoAtual.slice(2, 5);
        const parte3 = textoAtual.slice(5, 8);
        const parte4 = textoAtual.slice(8, 12);
        const parte5 = textoAtual.slice(12, 14);
        
        cnpj.value = `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`; 
    }
    
    function removerMascaraCNPJ(cnpj) {
        cnpj.value = cnpj.value.replace(/[^0-9]/g, '');
    }

    document.querySelectorAll('[cpf]').forEach(cpfElement => {
        cpfElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            // Bloquear qualquer caractere que não seja número
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });

        cpfElement.addEventListener('blur', function () {
            aplicarMascaraCPF(this);
        });

        cpfElement.addEventListener('focus', function () {
            removerMascaraCPF(this);
        });
    });

    function aplicarMascaraCPF(cpf) {
        const textoAtual = cpf.value.replace(/[^0-9]/g, '');

        const parte1 = textoAtual.slice(0, 3);
        const parte2 = textoAtual.slice(3, 6);
        const parte3 = textoAtual.slice(6, 9);
        const parte4 = textoAtual.slice(9, 11);

        // Formato: 000.000.000-00
        cpf.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '-' + parte4 : ''}`;
    }

    function removerMascaraCPF(cpf) {
        cpf.value = cpf.value.replace(/[^0-9]/g, '');
    }


    document.querySelectorAll('[cep]').forEach(cepElement => {
        cepElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            // Permite teclas como backspace, delete, tab, enter e setas
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            // Restringe entrada apenas a números
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cepElement.addEventListener('blur', function () {
            aplicarMascaraCEP(this);
        });
    
        cepElement.addEventListener('focus', function () {
            removerMascaraCEP(this);
        });
    });
    
    function aplicarMascaraCEP(cep) {
        const textoAtual = cep.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 5);
        const parte2 = textoAtual.slice(5, 8);
        
        cep.value = `${parte1}-${parte2}`;
    }
    
    function removerMascaraCEP(cep) {
        cep.value = cep.value.replace(/[^0-9]/g, '');
    }
    
    document.querySelectorAll('[documento]').forEach(docElement => {
        docElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            // Bloquear qualquer caractere que não seja número
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });

        docElement.addEventListener('blur', function () {
            aplicarMascaraDocumento(this);
        });

        docElement.addEventListener('focus', function () {
            removerMascaraDocumento(this);
        });
    });

    function aplicarMascaraDocumento(el) {
        const texto = el.value.replace(/\D/g, '');

        if (texto.length <= 11) {
            // CPF: 000.000.000-00
            const parte1 = texto.slice(0, 3);
            const parte2 = texto.slice(3, 6);
            const parte3 = texto.slice(6, 9);
            const parte4 = texto.slice(9, 11);
            el.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '-' + parte4 : ''}`;
        } else {
            // CNPJ: 00.000.000/0000-00
            const parte1 = texto.slice(0, 2);
            const parte2 = texto.slice(2, 5);
            const parte3 = texto.slice(5, 8);
            const parte4 = texto.slice(8, 12);
            const parte5 = texto.slice(12, 14);
            el.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '/' + parte4 : ''}${parte5 ? '-' + parte5 : ''}`;
        }
    }

    function removerMascaraDocumento(el) {
        el.value = el.value.replace(/\D/g, '');
    }

}